import { render } from "./FDStatus.vue?vue&type=template&id=81b8e57c&scoped=true"
import script from "./FDStatus.vue?vue&type=script&lang=js"
export * from "./FDStatus.vue?vue&type=script&lang=js"

import "./FDStatus.vue?vue&type=style&index=0&id=81b8e57c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b8e57c"]])

export default __exports__